/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ECaseStatusRequest = 'NewUnAssigned' | 'Pending' | 'Repairing' | 'Delayed' | 'PaymentWaiting' | 'Finished' | 'Returned' | 'Received' | 'Closed' | 'Importance' | 'PaymentInWarehouse' | 'All';

export const ECaseStatusRequest = {
    NewUnAssigned: 'NewUnAssigned' as ECaseStatusRequest,
    Pending: 'Pending' as ECaseStatusRequest,
    Repairing: 'Repairing' as ECaseStatusRequest,
    Delayed: 'Delayed' as ECaseStatusRequest,
    PaymentWaiting: 'PaymentWaiting' as ECaseStatusRequest,
    Finished: 'Finished' as ECaseStatusRequest,
    Returned: 'Returned' as ECaseStatusRequest,
    Received: 'Received' as ECaseStatusRequest,
    Closed: 'Closed' as ECaseStatusRequest,
    Importance: 'Importance' as ECaseStatusRequest,
    PaymentInWarehouse: 'PaymentInWarehouse' as ECaseStatusRequest,
    All: 'All' as ECaseStatusRequest
};

